export type GroupType = '43' | '34' | '45' | '54'

export enum GroupEnum {
	fourThree = '43',
	threeFour = '34',
	fourFive = '45',
	fiveFour = '54'
}
